import { Modal } from '@zambezi/sdk/modal';
import React from 'react';

export interface LogoutModalProps {
  onCancel?: () => void;
  onConfirm?: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({ onCancel, onConfirm }) => {
  return (
    <Modal
      confirm="Log out"
      onConfirm={onConfirm}
      cancel="Cancel"
      onCancel={onCancel}
      title="Are you sure you want to log out?"
      open={true}
    >
      If you leave this page, any unsaved changes will be lost.
    </Modal>
  );
};

export default LogoutModal;
